module.exports = __webpack_public_path__ + "img/dans-photo.4068e51d.png";